<template>
  <transition name="slide">
    <section
      v-if="showMCC"
      class="flex justify-between items-center fixed bottom-1 left-1 right-1 z-[99999] bg-white m-1 w-[100%] p-2 rounded-[8px] border-[10px] border-inputGrey-500"
    >
      <div class="flex gap-2 items-center">
        <div
          class="rounded-full bg-gray-50 w-[24px] h-[24px] px-1 py-2 border-[0.5px] border-inputGrey-600 text-sm font-semibold leading-[14.32px] flex items-center justify-center"
        >
          {{ selected }}
        </div>
        <p class="font-semibold text-base leading-6 text-gray-700">
          {{ entity }} {{ translateText("common.selected") }}
        </p>
      </div>

      <div class="flex gap-3">
        <slot name="buttons"></slot>
        <!-- <button
          @click="openPasswordConfirm"
          class="w-[131px] flex justify-center items-center gap-[10px] rounded-[8px] py-[4px] px-2 border border-[#D44333 bg-gray-50 text-[#AE372A]"
        >
          <i class="text-xs font-bold pi pi-times"></i>
          <p class="font-medium text-[16px]">{{ NegativeButton }}</p>
        </button>
        <button
          v-if="splitButton"
          @click="close"
          class="w-[131px] flex justify-center items-center gap-[10px] rounded-[8px] py-[4px] px-2 bg-estationsGreen-500"
        >
          <img src="@/assets/svg/approve.svg" />
          <p class="text-[#ffff] font-medium text-[16px]">
            {{ PositiveButton }}
          </p>
        </button> -->
      </div>
    </section>
  </transition>
</template>

<script>
import ButtonComp from "../Buttons/Button.vue";
import { translateText } from "@/core/helpers/utility";
export default {
  name: "ConfirmationModal",

  props: {
    isConfirmationModalOpen: {
      type: Boolean,
      required: true,
    },
    splitButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    closeConfirmationModal: {
      type: Function,
      required: false,
    },

    selected: {
      type: Number,
      required: true,
      default: 0,
    },
    entity: {
      type: String,
      required: false,
      default: "Items",
    },
  },
  components: {
    ButtonComp,
  },

  data() {
    return {
      translateText,
      showMCC: false,
    };
  },

  methods: {
    close() {
      this.showMCC = false;
      this.closeConfirmationModal();
    },
    openPasswordConfirm() {
      // this.showMCC = false;
      this.openPasswordConfirm();
    },
    imageSrc(icon) {
      return new URL(`../../assets/svg/${icon}`, import.meta.url).href;
    },
  },
  watch: {
    isConfirmationModalOpen() {
      this.showMCC = this.isConfirmationModalOpen;
      // if (this.isConfirmationModalOpen) {
      //   this.showMCC = true;
      // }
    },
  },
};
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateY(100%);
}

.slide-enter-to,
.slide-leave-from {
  transform: translateY(0);
}
</style>
